type Nullish<T> = T | null | undefined;

type ClassNameArg = string | undefined | Record<string, Nullish<boolean>>;

export const classNames = (...args: ClassNameArg[]) => {
    const classes: string[] = [];

    for (const arg of args) {
        if (typeof arg === "string") {
            classes.push(arg);
        } else if (arg) {
            for (const className in arg) {
                if (arg[className]) {
                    classes.push(className);
                }
            }
        }
    }

    return classes.join(" ");
};
